import { FC } from 'react'
import { SvgProps } from './svgProps'

const NavigationBackIcon: FC<SvgProps> = ({ width, height, color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 42"
    fill={color || '#000'}
    width={width || 16}
    height={height || 16}
  >
    <path d="M8.1 21 23.3 5.7c.4-.4.7-1 .7-1.6 0-.6-.2-1.2-.7-1.6L22 1.2c-.4-.4-1-.7-1.6-.7s-1.2.2-1.6.7L.7 19.4c-.5.4-.7 1-.7 1.6 0 .6.2 1.2.7 1.6l18.2 18.2c.4.4 1 .7 1.6.7.6 0 1.2-.2 1.6-.7l1.3-1.3c.9-.9.9-2.3 0-3.2L8.1 21z" />
  </svg>
)

export default NavigationBackIcon
